export default {
  types: [
    "Select",
    "Multi-Select",
    "Textbox",
    "Checkboxes",
    "Radio Buttons",
    "Tags",
  ],
  shards: {
    RetailerContact: "Contact",
    Retailer: "Customer",
    Prospect: "Prospect",
    Product: "Product",
    ProductCatalog: "Product Catalog",
    "Media:Products": "Product Media",
    "Media:Documents": "Document",
    Media: "Media",
    Dealer: "Dealer",
    Blog: "Blog",
    Order: "Order",
    Vendor: "Vendor"
  },
  filters: [{ text: "Search", operation: "" }, { groupBy: "Role" }],
  pageSize: 24,
  orderBy: "-LastLogInAttempt,Id",
  sortOptions: {
    Sku: "Item Number: Low to High",
    "-Sku": "Item Number: High to Low",
    CompanyName: "CompanyName: A to Z",
    "-CompanyName": "CompanyName: Z to A",
    Cost: "Cost: Low to High",
    "-Cost": "Cost: High to Low",
    "LastLogInAttempt,Sku": "Created: Newest",
    "-LastLogInAttempt,Sku": "Created: Oldest",
    Active: "Active: A to Z",
    "-Active": "Active: Z to A",
  },
};

export const prepTagsForSave = (tags) => {
  const req = {};

  for (const kind in tags) {
    if (tags[kind]) {
      if (Array.isArray(tags[kind])) req[kind] = tags[kind];
      else req[kind] = [tags[kind]];
    }
  }
  return req;
};
